// extracted by mini-css-extract-plugin
export default {"container":"Article_container__dsYWs","Main":"Article_Main__dDFG2","Big":"Article_Big__qNae+","Figure":"Article_Figure__ZNt7e","ArticleContent":"Article_ArticleContent__DMCBF"};